import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api, {CameraHasObjects} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  cameraId: number
  onError?: (error: unknown) => void
  enabled?: boolean
  includes?: Array<string>
}

export default function useObjects({cameraId, onError, includes = [], enabled = true}: Props) {
  const query = useQuery<CameraHasObjects[]>({
    enabled,
    queryKey: [QueryKeyEnum.OBJECTS, cameraId, includes],
    queryFn: async () =>
      (
        await api.object.getAllObjectsOnCamera({
          cameraId,
          includes,
        })
      ).data.data,
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
